export default __webpack_public_path__ + "static/captain-male-7b473f1e13c1fb51d450ccf31fdcd778.png";